module.exports = __webpack_public_path__ + "static/media/user.7265e358.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/user.svg
// module id = 112
// module chunks = 0